import React from 'react';
import classes from './Spinner.module.css';
import { ReactComponent as Logo } from '../../assets/only-logo.svg';

const SpinningLogo = () => {
  return <Logo style={{ fontSize: 90 }} className={classes.rotating} />;
};

export default SpinningLogo;